/* ── Treekmarket Theme JS ─────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {
  initLang();
  initNav();
  initCart();
  initPricingWidget();
  initSimpleVariants();
  initGallery();
  initSpecsTabs();
  initScrollStory();
  initCollectionFilters();
  initDesignCta();
  initBoxFinder();
});

/* ── Language toggle ────────────────────────────────────────────────────── */
function initLang() {
  const btn = document.querySelector('[data-lang-toggle]');
  if (!btn) return;
  const set = (lang) => {
    document.documentElement.setAttribute('data-lang', lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    localStorage.setItem('tm-lang', lang);
  };
  // Restore saved language on every page load (default: 'ar')
  const saved = localStorage.getItem('tm-lang') || 'ar';
  set(saved);
  btn.addEventListener('click', () => {
    const current = document.documentElement.getAttribute('data-lang') || 'ar';
    set(current === 'ar' ? 'en' : 'ar');
  });
}

/* ── Collection filters drawer (mobile) ───────────────────────────────── */
function initCollectionFilters() {
  const toggle  = document.querySelector('[data-filters-toggle]');
  const closeBtn= document.querySelector('[data-filters-close]');
  const filters = document.querySelector('[data-filters]');
  const overlay = document.querySelector('[data-filters-overlay]');
  if (!toggle || !filters) return;

  const open  = () => { filters.classList.add('is-open'); overlay?.classList.add('is-open'); toggle.setAttribute('aria-expanded','true'); document.body.style.overflow = 'hidden'; };
  const close = () => { filters.classList.remove('is-open'); overlay?.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false'); document.body.style.overflow = ''; };

  toggle.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
}

/* ── Scroll-driven story (Section 8) ──────────────────────────────────── */
function initScrollStory() {
  const story = document.querySelector('.scroll-story');
  if (!story) return;

  const triggers = story.querySelectorAll('.scroll-story__trigger');
  const panels   = story.querySelectorAll('.scroll-story__panel');
  const images   = story.querySelectorAll('.scroll-story__image');
  if (triggers.length < 2) return;

  // Set total scroll height: one viewport per chapter
  story.style.height = (triggers.length * 100) + 'vh';

  const setActive = (idx) => {
    panels.forEach((p, i) => p.classList.toggle('is-active', i === idx));
    images.forEach((img, i) => img.classList.toggle('is-active', i === idx));
  };

  // Each trigger spans 1/N of the section height; whichever is centered in
  // the viewport drives the active panel.
  const observer = new IntersectionObserver((entries) => {
    // Pick the entry closest to viewport center
    let best = null;
    let bestRatio = 0;
    entries.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio > bestRatio) {
        best = e.target;
        bestRatio = e.intersectionRatio;
      }
    });
    if (best) {
      const idx = parseInt(best.dataset.trigger, 10);
      setActive(idx);
    }
  }, {
    root: null,
    rootMargin: '-40% 0px -40% 0px', // active when centered in viewport
    threshold: [0, 0.25, 0.5, 0.75, 1],
  });

  triggers.forEach(t => observer.observe(t));
}

/* ── Mobile nav ─────────────────────────────────────────────────────────── */
function initNav() {
  const toggle = document.querySelector('.nav-toggle');
  const nav    = document.querySelector('#site-nav, .nav');
  if (!toggle || !nav) return;

  const closeNav = () => {
    toggle.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
    document.body.style.overflow = !open ? 'hidden' : '';
  });

  // Tap-to-open dropdowns on mobile (click on parent li link)
  nav.querySelectorAll('li.has-dropdown > a').forEach(a => {
    a.addEventListener('click', (e) => {
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        const li = a.closest('li');
        const wasOpen = li.classList.contains('is-open');
        // close all dropdowns first
        nav.querySelectorAll('li.has-dropdown').forEach(l => l.classList.remove('is-open'));
        if (!wasOpen) li.classList.add('is-open');
      }
    });
  });

  // Close nav when a dropdown item link is clicked
  nav.querySelectorAll('.nav__dropdown a').forEach(a => {
    a.addEventListener('click', closeNav);
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) {
      closeNav();
    }
  });
}

/* ── Cart drawer ────────────────────────────────────────────────────────── */
function initCart() {
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (!drawer) return;

  const open  = () => { drawer.classList.add('is-open');  drawer.setAttribute('aria-hidden','false'); overlay.classList.add('is-visible'); };
  const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');  overlay.classList.remove('is-visible'); };

  document.querySelectorAll('[data-cart-toggle]').forEach(b => b.addEventListener('click', open));
  document.querySelectorAll('[data-cart-close]').forEach(b  => b.addEventListener('click', close));
  overlay.addEventListener('click', close);

  // Checkout button — explicit redirect in case the <a> href is suppressed
  drawer.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-checkout]');
    if (btn) { window.location.href = '/checkout'; }
  });

  // Quantity controls + remove
  drawer.addEventListener('click', async (e) => {
    const dec = e.target.closest('[data-action="decrease"]');
    const inc = e.target.closest('[data-action="increase"]');
    const rem = e.target.closest('[data-remove]');
    if (dec) await updateCart(dec.dataset.key, -1);
    if (inc) await updateCart(inc.dataset.key,  1);
    if (rem) await removeFromCart(rem.dataset.remove);
  });
}

async function updateCart(key, delta) {
  const res  = await fetch('/cart.js');
  const cart = await res.json();
  const item = cart.items.find(i => i.key === key);
  if (!item) return;
  const newQty = item.quantity + delta;
  if (newQty < 1) { await removeFromCart(key); return; }
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty }),
  });
  await refreshCartUI();
}

async function removeFromCart(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  });
  await refreshCartUI();
}

async function refreshCartUI() {
  const res  = await fetch('/cart.js');
  const cart = await res.json();

  // Update count badge
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
  });

  // Update subtotal
  const sub = document.getElementById('cart-subtotal');
  if (sub) sub.textContent = formatMoney(cart.total_price);

  // Re-render items
  const itemsEl = document.getElementById('cart-items');
  if (!itemsEl) return;
  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    return;
  }
  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__image-wrap">
        <img src="${item.image}" alt="${item.title}" class="cart-item__image" width="80">
      </a>
      <div class="cart-item__info">
        <p class="cart-item__title">${item.product_title}</p>
        ${item.properties?.Size ? `<p class="cart-item__variant">${item.properties.Size} · ${item.properties['Print Type'] || ''}</p>` : ''}
        <div class="cart-item__actions">
          <div class="cart-item__qty">
            <button data-action="decrease" data-key="${item.key}">−</button>
            <span>${item.quantity}</span>
            <button data-action="increase" data-key="${item.key}">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
        </div>
      </div>
      <button class="cart-item__remove" data-remove="${item.key}" aria-label="Remove">✕</button>
    </div>
  `).join('');
}

function getCurrency() {
  return document.documentElement.dataset.lang === 'ar' ? 'ر.س' : 'SAR';
}
function formatMoney(cents) {
  return (cents / 100).toFixed(2) + ' ' + getCurrency();
}

/* ── Product card: Add to Cart ──────────────────────────────────────────── */
async function pcAddToCart(btn) {
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  const origHTML = btn.innerHTML;
  btn.innerHTML = '<span>...</span>';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    await refreshCartUI();

    // Open cart drawer
    const drawer  = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay?.classList.add('is-visible');
    }

    // Brief success state
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    btn.innerHTML = '<span class="t-en">Added!</span><span class="t-ar">تمت الإضافة!</span>';
    setTimeout(() => {
      btn.classList.remove('is-added');
      btn.innerHTML = origHTML;
    }, 2000);
  } catch (e) {
    btn.classList.remove('is-loading');
    btn.innerHTML = origHTML;
  }
}

/* ── Simple variant selector (non-matrix products) ───────────────────────── */
function initSimpleVariants() {
  const dataEl = document.getElementById('product-variants-data');
  if (!dataEl) return;

  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch(e) { return; }

  const variantInput = document.getElementById('simple-variant-id');
  const priceEl      = document.getElementById('simple-variant-price');

  function getSelected() {
    const sel = {};
    document.querySelectorAll('.config-opt.active[data-opt-pos]').forEach(b => {
      sel[parseInt(b.dataset.optPos)] = b.dataset.optVal;
    });
    return sel;
  }

  function findVariant(sel) {
    return variants.find(v =>
      Object.entries(sel).every(([pos, val]) => v['option' + pos] === val)
    );
  }

  const mainImg   = document.getElementById('main-product-image');
  const thumbBtns = document.querySelectorAll('.product-gallery__thumb');

  function switchImage(src) {
    if (!mainImg || !src) return;
    // Ensure protocol
    if (src.startsWith('//')) src = 'https:' + src;
    mainImg.src = src;
    mainImg.srcset = '';

    // Highlight matching thumbnail
    const srcFile = src.split('?')[0].split('/').pop();
    thumbBtns.forEach(btn => {
      const btnFile = (btn.dataset.imageUrl || '').split('?')[0].split('/').pop();
      btn.classList.toggle('active', btnFile === srcFile);
    });
  }

  document.querySelectorAll('[data-opt-pos]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll(`[data-opt-pos="${btn.dataset.optPos}"]`)
          .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const match = findVariant(getSelected());
      if (!match) return;

      if (variantInput) variantInput.value = match.id;

      if (priceEl) {
        priceEl.textContent = match.price > 0
          ? (match.price / 100).toFixed(2) + ' ' + getCurrency()
          : '';
      }

      // Switch image using variant's assigned image (works for /files/ and /products/ CDN paths)
      if (match.featured_image && match.featured_image.src) {
        switchImage(match.featured_image.src);
      }
    });
  });

  // Add percentage discount badges to quantity option buttons
  const simpleQtyDiscounts = { '50': '5%', '100': '10%', '500': '15%', '1000': '20%' };
  document.querySelectorAll('[data-opt-group]').forEach(group => {
    const label = group.closest('.config-group')?.querySelector('.config-group__label');
    const labelText = label ? label.textContent.trim().toLowerCase() : '';
    if (!labelText.includes('quantity') && !labelText.includes('كمية') && !labelText.includes('الكمية')) return;
    group.querySelectorAll('.config-opt[data-opt-val]').forEach(btn => {
      const val = btn.dataset.optVal;
      if (!simpleQtyDiscounts[val]) return;
      const badge = document.createElement('span');
      badge.className = 'qty-tier__discount';
      badge.textContent = simpleQtyDiscounts[val];
      btn.style.position = 'relative';
      btn.appendChild(badge);
    });
  });

  // Inject >1000 button after the Quantity option group
  const allOptGroups = document.querySelectorAll('[data-opt-group]');
  allOptGroups.forEach(group => {
    const label = group.closest('.config-group')?.querySelector('.config-group__label');
    const labelText = label ? label.textContent.trim().toLowerCase() : '';
    if (!labelText.includes('quantity') && !labelText.includes('كمية') && !labelText.includes('الكمية')) return;
    if (group.querySelector('.qty-tier--quote')) return;
    const lastBtn = group.querySelector('.config-opt:last-child');
    if (!lastBtn) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'over-1000-btn';
    btn.className = 'config-opt qty-tier--quote';
    btn.dataset.type = 'quote';
    btn.textContent = '>1000';
    btn.addEventListener('click', () => {
      group.querySelectorAll('.config-opt').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      setQuoteModeSimple(true);
    });
    lastBtn.insertAdjacentElement('afterend', btn);
  });

  function setQuoteModeSimple(on) {
    document.querySelectorAll('.product-cta a[href*="wa.me"]').forEach(b => b.style.display = on ? 'block' : 'none');
    document.querySelectorAll('.product-cta button[type="submit"]').forEach(b => b.style.display = on ? 'none' : 'block');
    if (!on) document.querySelectorAll('.qty-tier--quote').forEach(b => b.classList.remove('active'));
  }

  // Reset quote mode when any other option is clicked
  document.querySelectorAll('[data-opt-pos]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!btn.classList.contains('qty-tier--quote')) setQuoteModeSimple(false);
    }, true);
  });
}

/* ── Specs / description tabs ───────────────────────────────────────────── */
function initSpecsTabs() {
  const tabs = document.querySelectorAll('.specs-tab');
  if (!tabs.length) return;
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      document.querySelectorAll('.specs-panel').forEach(p => p.classList.remove('active'));
      const panel = document.getElementById('tab-' + tab.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ── Dynamic pricing widget ─────────────────────────────────────────────── */
function initPricingWidget() {
  const widget = document.getElementById('pricing-widget');
  if (!widget) return;

  const rawMatrix = widget.dataset.matrix;
  if (!rawMatrix) return;

  let matrix;
  try { matrix = JSON.parse(rawMatrix); } catch { return; }

  let selectedSize      = matrix.sizes?.[0] || null;
  let selectedPrint     = 'no_print';
  let selectedMaterial  = 'kraft';
  let selectedCoverage  = 'outside';
  let selectedQty       = matrix.tiers?.[0] || 1;
  let selectedTierIndex = 0;

  const unitPriceEl     = document.getElementById('unit-price');
  const totalPriceEl    = document.getElementById('total-price');
  const summaryQtyLabel = document.getElementById('summary-qty-label');
  const addToCartBtn    = document.getElementById('add-to-cart');
  const addToCartText   = document.getElementById('add-to-cart-text');
  const cartQtyInput    = document.getElementById('cart-qty');
  const cartSizeInput   = document.getElementById('cart-size');
  const cartPrintInput  = document.getElementById('cart-print');
  const cartMatInput    = document.getElementById('cart-material');
  const cartCovInput    = document.getElementById('cart-coverage');
  const customQtyInput  = document.getElementById('custom-qty');
  const quoteBtns       = document.querySelectorAll('.product-cta a[href*="wa.me"]');

  // Add percentage discount badges to quantity tier buttons
  const qtyDiscounts = { '50': '5%', '100': '10%', '500': '15%', '1000': '20%' };
  widget.querySelectorAll('.qty-tier[data-qty]').forEach(btn => {
    const qty = btn.dataset.qty;
    if (!qtyDiscounts[qty]) return;
    const badge = document.createElement('span');
    badge.className = 'qty-tier__discount';
    badge.textContent = qtyDiscounts[qty];
    btn.appendChild(badge);
  });

  // Inject >1000 button after last tier button
  let over1000Btn = document.getElementById('over-1000-btn');
  if (!over1000Btn) {
    const allTierBtns = widget.querySelectorAll('.qty-tier');
    if (allTierBtns.length) {
      const lastTier = allTierBtns[allTierBtns.length - 1];
      over1000Btn = document.createElement('button');
      over1000Btn.type = 'button';
      over1000Btn.id = 'over-1000-btn';
      over1000Btn.className = 'qty-tier qty-tier--quote';
      over1000Btn.dataset.type = 'quote';
      over1000Btn.textContent = '>1000';
      lastTier.insertAdjacentElement('afterend', over1000Btn);
    }
  }

  function getPrice() {
    if (!matrix.prices) return 0;
    // Support flat pricing (prices.default) or size-based pricing
    const priceRow = matrix.prices['default'] || (selectedSize && matrix.prices[selectedSize]) || Object.values(matrix.prices)[0];
    if (!priceRow) return 0;
    const basePrice  = priceRow[selectedTierIndex] ?? priceRow[0] ?? 0;
    const printMult  = matrix.print_multipliers?.[selectedPrint]           ?? 1;
    const matMult    = matrix.material_multipliers?.[selectedMaterial]     ?? 1;
    const covMult    = (selectedPrint !== 'no_print')
                         ? (matrix.coverage_multipliers?.[selectedCoverage] ?? 1)
                         : 1;
    return parseFloat((basePrice * printMult * matMult * covMult).toFixed(2));
  }

  function updateDisplay() {
    const unitPrice = getPrice();
    const total     = parseFloat((unitPrice * selectedQty).toFixed(2));

    if (summaryQtyLabel) summaryQtyLabel.textContent = selectedQty + ' units';
    if (unitPriceEl)     unitPriceEl.textContent     = unitPrice > 0 ? unitPrice.toFixed(2) + ' ' + getCurrency() + ' / unit' : '— ' + getCurrency() + ' / unit';
    if (totalPriceEl)    totalPriceEl.textContent    = unitPrice > 0 ? total.toFixed(2) + ' ' + getCurrency()             : '— ' + getCurrency();

    if (addToCartBtn) {
      addToCartBtn.disabled = unitPrice <= 0;
      if (addToCartText) {
        addToCartText.textContent = unitPrice > 0
          ? `Add ${selectedQty} units to Cart`
          : 'Select options above';
      }
    }

    if (cartQtyInput)   cartQtyInput.value   = selectedQty;
    if (cartSizeInput)  cartSizeInput.value  = selectedSize || '';
    if (cartPrintInput) cartPrintInput.value = selectedPrint.replace(/_/g, ' ');
    if (cartMatInput)   cartMatInput.value   = selectedMaterial;
    if (cartCovInput)   cartCovInput.value   = selectedCoverage;
  }

  // Config option buttons (size / print / material / coverage)
  widget.querySelectorAll('.config-opt').forEach(btn => {
    btn.addEventListener('click', () => {
      const type  = btn.dataset.type;
      const value = btn.dataset.value;

      widget.querySelectorAll(`.config-opt[data-type="${type}"]`).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      if (type === 'size')     selectedSize     = value;
      if (type === 'print')    selectedPrint    = value;
      if (type === 'material') selectedMaterial = value;
      if (type === 'coverage') selectedCoverage = value;

      // Hide coverage when no print is selected
      const coverageGroup = document.querySelector('#coverage-options')?.closest('.config-group');
      if (coverageGroup) {
        coverageGroup.style.display = selectedPrint === 'no_print' ? 'none' : '';
      }

      updateDisplay();
    });
  });

  function setQuoteMode(on) {
    quoteBtns.forEach(b => b.style.display = on ? 'block' : 'none');
    if (addToCartBtn) addToCartBtn.style.display = on ? 'none' : 'block';
    if (!on && over1000Btn) over1000Btn.classList.remove('active');
  }

  // Quantity tier buttons
  widget.querySelectorAll('.qty-tier').forEach(btn => {
    btn.addEventListener('click', () => {
      widget.querySelectorAll('.qty-tier').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      if (btn.dataset.type === 'quote') {
        setQuoteMode(true);
        return;
      }

      setQuoteMode(false);
      selectedTierIndex = parseInt(btn.dataset.index, 10);
      selectedQty       = parseInt(btn.dataset.qty, 10);
      if (customQtyInput) customQtyInput.value = '';
      updateDisplay();
    });
  });

  // Custom quantity input
  if (customQtyInput) {
    customQtyInput.addEventListener('input', () => {
      const val = parseInt(customQtyInput.value, 10);
      const moq = matrix.moq || 1;
      if (!val || val < moq) return;
      setQuoteMode(false);
      selectedQty = val;

      const tiers = matrix.tiers || [];
      let bestIndex = 0;
      for (let i = 0; i < tiers.length; i++) {
        if (val >= tiers[i]) bestIndex = i;
      }
      selectedTierIndex = bestIndex;
      widget.querySelectorAll('.qty-tier').forEach(b => b.classList.remove('active'));
      updateDisplay();
    });
  }

  // Hide coverage group initially (no print is default)
  const coverageGroup = document.querySelector('#coverage-options')?.closest('.config-group');
  if (coverageGroup) coverageGroup.style.display = 'none';

  // Sync visible dimension inputs → hidden form properties
  ['length', 'width', 'height'].forEach(dim => {
    const visible = document.getElementById('dim-' + dim);
    const hidden  = document.getElementById('hidden-dim-' + dim);
    if (visible && hidden) {
      visible.addEventListener('input', () => { hidden.value = visible.value; });
    }
  });

  // Specs tabs
  document.querySelectorAll('.specs-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      document.querySelectorAll('.specs-tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.specs-panel').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById('tab-' + target)?.classList.add('active');
    });
  });

  updateDisplay();
}

/* ── Product image gallery ──────────────────────────────────────────────── */
function initGallery() {
  const mainImg = document.getElementById('main-product-image');
  if (!mainImg) return;
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      mainImg.src = thumb.dataset.imageUrl;
      mainImg.srcset = '';  // clear srcset so src takes effect
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

/* ── Add to cart → open drawer ──────────────────────────────────────────── */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action="/cart/add"]') || e.target.closest('[data-form="cart"]');
  if (!form) return;
  e.preventDefault();
  const data = new FormData(form);
  await fetch('/cart/add.js', { method: 'POST', body: data });
  await refreshCartUI();
  document.getElementById('cart-drawer')?.classList.add('is-open');
  document.getElementById('cart-overlay')?.classList.add('is-visible');
});

/* ── Live viewer counter ─────────────────────────────────────────────── */
(function () {
  const els = [document.getElementById('live-viewers'), document.getElementById('live-viewers-ar')];
  if (!els[0]) return;

  let count = parseInt(els[0].textContent, 10);
  const MAX = 14;

  function bump() {
    const up = Math.random() < 0.6;
    if (up && count < MAX) count++;
    else if (!up && count > 3) count--;
    els.forEach(el => { if (el) el.textContent = count; });
    setTimeout(bump, 8000 + Math.random() * 14000);
  }

  setTimeout(bump, 10000 + Math.random() * 10000);
})();

/* ── Design CTA — Three.js open cardboard box ───────────────────────── */
function initDesignCta() {
  const canvas = document.getElementById('dcta-canvas');
  if (!canvas || typeof THREE === 'undefined') return;

  // Use the parent stage's declared size so we always get real dimensions
  const stage = canvas.closest('.dcta__stage');
  const cw = (stage ? stage.offsetWidth  : 0) || 380;
  const ch = (stage ? stage.offsetHeight : 0) || 380;

  const W_BOX = 2.5, H_BOX = 1.6, D_BOX = 1.9;
  const MFH   = D_BOX * 0.46;
  const mFL   = W_BOX * 0.44;

  /* ── Scene ── */
  const scene  = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(42, cw / ch, 0.1, 100);
  camera.position.set(1.6, 2.2, 5.5);
  camera.lookAt(0, 0.1, 0);

  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  // false = don't let Three.js override our CSS width/height
  renderer.setSize(cw, ch, false);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  /* ── Lighting ── */
  scene.add(new THREE.AmbientLight(0xfff5e0, 0.55));

  const sun = new THREE.DirectionalLight(0xffe8c0, 1.4);
  sun.position.set(4, 6, 5);
  scene.add(sun);

  const purp = new THREE.PointLight(0xa855f7, 2.5, 18);
  purp.position.set(-4, 3, 3);
  scene.add(purp);

  const fill = new THREE.PointLight(0xffffff, 0.4);
  fill.position.set(-2, 0, -4);
  scene.add(fill);

  /* ── Materials ── */
  const outside = new THREE.MeshStandardMaterial({
    color: 0xbc7d3a, roughness: 0.88, metalness: 0.0, side: THREE.FrontSide
  });
  const inside = new THREE.MeshStandardMaterial({
    color: 0x9c5f22, roughness: 0.92, metalness: 0.0, side: THREE.BackSide
  });
  // Each panel gets both faces via two meshes sharing the same geometry
  function dualPlane(w, h) {
    const geo = new THREE.PlaneGeometry(w, h);
    const g   = new THREE.Group();
    g.add(new THREE.Mesh(geo, outside));
    g.add(new THREE.Mesh(geo, inside));
    return g;
  }

  const box = new THREE.Group();

  /* ── 5-sided body ── */
  const bottom = dualPlane(W_BOX, D_BOX);
  bottom.rotation.x = -Math.PI / 2;
  bottom.position.y = -H_BOX / 2;
  box.add(bottom);

  const frontW = dualPlane(W_BOX, H_BOX);
  frontW.position.set(0, 0, D_BOX / 2);
  box.add(frontW);

  const backW = dualPlane(W_BOX, H_BOX);
  backW.rotation.y = Math.PI;
  backW.position.set(0, 0, -D_BOX / 2);
  box.add(backW);

  const leftW = dualPlane(D_BOX, H_BOX);
  leftW.rotation.y = Math.PI / 2;
  leftW.position.set(-W_BOX / 2, 0, 0);
  box.add(leftW);

  const rightW = dualPlane(D_BOX, H_BOX);
  rightW.rotation.y = -Math.PI / 2;
  rightW.position.set(W_BOX / 2, 0, 0);
  box.add(rightW);

  /* ── Flaps (pivot groups so rotation looks natural) ── */
  function addFlap(px, py, pz, rx, ry, rz, fw, fh, meshRY) {
    const pivot = new THREE.Group();
    pivot.position.set(px, py, pz);
    pivot.rotation.set(rx, ry, rz);
    const panel = dualPlane(fw, fh);
    if (meshRY) panel.rotation.y = meshRY;
    panel.position.set(0, -fh / 2, 0);
    pivot.add(panel);
    box.add(pivot);
  }

  // Front major flap — fold forward ~85°
  addFlap(0, H_BOX/2, D_BOX/2,  Math.PI * 0.47, 0, 0, W_BOX, MFH, 0);
  // Back major flap — fold backward ~55°
  addFlap(0, H_BOX/2, -D_BOX/2, -Math.PI * 0.32, 0, 0, W_BOX, MFH, 0);
  // Left minor flap — fold left ~50°
  addFlap(-W_BOX/2, H_BOX/2, 0, 0, 0, -Math.PI * 0.3, D_BOX, mFL, Math.PI / 2);
  // Right minor flap — fold right ~50°
  addFlap(W_BOX/2,  H_BOX/2, 0, 0, 0,  Math.PI * 0.3, D_BOX, mFL, -Math.PI / 2);

  box.position.y = -0.2;
  scene.add(box);

  /* ── Mouse interaction ── */
  let mx = 0;
  document.addEventListener('mousemove', e => {
    mx = (e.clientX / window.innerWidth - 0.5) * 2;
  });

  /* ── Animate ── */
  let t = 0, targetRY = 0;
  (function animate() {
    requestAnimationFrame(animate);
    t += 0.009;

    box.position.y = -0.2 + Math.sin(t) * 0.18;
    targetRY += 0.007;
    box.rotation.y += (targetRY + mx * 0.4 - box.rotation.y) * 0.04;
    box.rotation.x += (-mx * 0.08 - box.rotation.x) * 0.04;

    renderer.render(scene, camera);
  })();

  /* ── Resize ── */
  window.addEventListener('resize', () => {
    const nw = (stage ? stage.offsetWidth  : 0) || 380;
    const nh = (stage ? stage.offsetHeight : 0) || 380;
    renderer.setSize(nw, nh, false);
    camera.aspect = nw / nh;
    camera.updateProjectionMatrix();
  });
}

/* ── Box Dimension Finder ────────────────────────────────────────────────── */
var BOX_CATALOG = [
  { title: 'Reinforced Premium E-Commerce Box',       url: '/products/e-commerce-box-9',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/a7a5809f-39f4-43a8-af7f-21d789852204.png', price: '3.36', l: 31, w: 22, h: 13 },
  { title: 'Square Product E-Commerce Box',           url: '/products/e-commerce-box-8',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/2407d70e-3591-4583-a619-8a37bcc57007.png', price: '1.98', l: 20, w: 20, h: 10 },
  { title: 'Premium Large E-Commerce Box',            url: '/products/e-commerce-box-10',   img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/4120400b-182a-4a06-a061-fdc3c8527a41.png', price: '3.72', l: 36, w: 30, h: 8  },
  { title: 'Luxury Gift & Cosmetic E-Commerce Box',   url: '/products/e-commerce-box-7',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/720123c9-512a-422a-b385-df474fa67fe1.png', price: '2.70', l: 22, w: 14, h: 13 },
  { title: 'Heavy-Duty E-commerce Box',               url: '/products/e-commerce-box-6',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/9b5cf34b-c0e8-4800-a065-563dea1db15b.png', price: '3.44', l: 36, w: 30, h: 8  },
  { title: 'Medium Delivery E-Commerce Box',          url: '/products/e-commerce-box-5',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/31ddf4f8-91f7-4e3a-b558-289a5b4481d4.png', price: '3.08', l: 31, w: 22, h: 13 },
  { title: 'Premium Retail E-Commerce Box',           url: '/products/e-commerce-box-4',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/58ea7bc9-15a8-4cd5-9759-8eb16f707b37.png', price: '1.84', l: 22, w: 18, h: 6  },
  { title: 'Compact Everyday E-Commerce Box',         url: '/products/e-commerce-box-3',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/26d69fe0-7a66-4bf1-8c41-49b000c58ff3.png', price: '1.80', l: 16, w: 14, h: 8  },
  { title: 'Accessories & Small Product E-Commerce Box', url: '/products/e-commerce-box-2', img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/bd87950b-e1e2-4ba5-9e62-b47448e37241_da0407a1-ea18-431d-974e-e84c145edd1a.png', price: '1.88', l: 20, w: 14, h: 6.5 },
  { title: 'Premium Fashion E-Commerce Box',          url: '/products/e-commerce-box-1',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/6cb41130-ac24-43da-9f21-f6f5e3c13bc8.png', price: '3.44', l: 30, w: 22, h: 20 },
  { title: 'Small Cargo Box',                         url: '/products/cargo-box-small',     img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/1a4cb67d-702a-45c0-93a1-66d01cb30a9a.png', price: '22',   l: 40, w: 40, h: 40 },
  { title: 'Medium Cargo Box',                        url: '/products/medium-cargo-box',    img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/84f9b28e-a087-45c9-b76c-6e1d20774401.png', price: '25',   l: 48, w: 48, h: 50 },
  { title: 'Large Cargo Box',                         url: '/products/large-cargo-box',     img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/5322f773-cc24-468b-91bf-24155f458b16.png', price: '27',   l: 54, w: 54, h: 57 },
  { title: 'X-Large Cargo Box',                       url: '/products/x-large-cargo-box',   img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/8dc840ad-7be6-4599-b258-7cb39832ab3a.png', price: '30',   l: 61, w: 61, h: 72 },
  { title: 'Small Box',                               url: '/products/small-box',            img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/5656458d-8f22-4edf-af8d-5bd793388c1e.png', price: '0',    l: 25, w: 18, h: 19 },
  { title: 'Medium Box',                              url: '/products/medium-box',           img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/f85f72db-7574-4aeb-87ee-b0728773bc2e.png', price: '2.20', l: 30, w: 22, h: 25 },
  { title: 'Large Box',                               url: '/products/large-box',            img: 'https://cdn.shopify.com/s/files/1/0780/1959/2341/files/9adb42d3-7e5a-4c86-ac05-dd4a4ddf3499.png', price: '3.80', l: 43, w: 31, h: 31 },
];

function initBoxFinder() {
  if (!document.getElementById('box-finder')) return;

  // 3D Euclidean distance (cm)
  function dist3d(box, t) {
    return Math.sqrt(
      Math.pow(box.l - t.l, 2) +
      Math.pow(box.w - t.w, 2) +
      Math.pow(box.h - t.h, 2)
    );
  }

  // Read URL params — if present, reorder the product grid
  var params = new URLSearchParams(window.location.search);
  var l = parseFloat(params.get('l')) || 0;
  var w = parseFloat(params.get('w')) || 0;
  var h = parseFloat(params.get('h')) || 0;

  if (!l || !w || !h) return;

  var target = { l: l, w: w, h: h };

  var TOP_N = 3;

  // Sort catalog by distance, take top 3 handles
  var top3Handles = BOX_CATALOG.map(function(box) {
    return { handle: box.url.split('/').pop(), dist: dist3d(box, target) };
  }).sort(function(a, b) { return a.dist - b.dist; })
    .slice(0, TOP_N)
    .map(function(item) { return item.handle; });

  // Build handle → rank (0, 1, 2) lookup
  var rankMap = {};
  top3Handles.forEach(function(handle, i) { rankMap[handle] = i; });

  var grid = document.querySelector('.product-grid--collection');
  if (!grid) return;

  var cards = Array.from(grid.children);

  // Tag each card with its rank (or 9999 if not in top 3)
  cards.forEach(function(card) {
    var link = card.querySelector('a.product-card__link, a.product-card');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var handle = href.split('/products/').pop().split('?')[0];
    card.dataset.bfRank = rankMap.hasOwnProperty(handle) ? rankMap[handle] : 9999;
  });

  // Sort: top 3 first (rank 0–2), rest at 9999
  cards.sort(function(a, b) {
    return (parseInt(a.dataset.bfRank) || 9999) - (parseInt(b.dataset.bfRank) || 9999);
  });

  // Show only top 3, hide the rest
  cards.forEach(function(card, i) {
    var rank = parseInt(card.dataset.bfRank);
    card.style.display = (rank < TOP_N) ? '' : 'none';
    grid.appendChild(card);
  });

  // Badge on the best match
  var best = cards[0];
  if (best && parseInt(best.dataset.bfRank) === 0) {
    var badge = document.createElement('div');
    badge.className = 'bf-grid-badge';
    badge.innerHTML = '<span class="t-en">Best Match</span><span class="t-ar">الأنسب</span>';
    best.style.position = 'relative';
    best.prepend(badge);
  }
}
